module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#news",
      toString: function () {
        return this.url;
      }
    }